
import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-should-login',
  templateUrl: './should-login.component.html',
  styleUrls: ['./should-login.component.scss']
})
export class ShouldLoginComponent {
  constructor(private router: Router) { }

  public login($event: any) {
    $event.preventDefault();
    this.router.navigate(['/']);
  }
}